/*
 * @Author: your name
 * @Date: 2019-09-05 20:46:11
 * @LastEditTime: 2021-03-23 14:45:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-module/packages/components/dialog/index.js
 */
import ZDialog from './dialog.vue'
import ZProjectlog from './projectlog.vue'
import ZFavoritelog from './favoritelog.vue'
import ZAddProlog from './addProload.vue'
import ZSpeclog from './speclog.vue'
import ZInprojectlog from './inProjectlog.vue'
import ZAddresslog from './addresslog.vue'
import ZInvoicelog from './invoicelog.vue'
import ZAddFavorites from './add-favorites.vue'
import ZAddMembers from './add-members.vue'
import ZMateriallog from './materiallog.vue'
import ZLogin from './login.vue'

ZDialog.project = ZProjectlog
ZDialog.favorite = ZFavoritelog
ZDialog.addpro = ZAddProlog
ZDialog.spec = ZSpeclog
ZDialog.inproject = ZInprojectlog
ZDialog.address = ZAddresslog
ZDialog.invoice = ZInvoicelog
ZDialog.addFavorites = ZAddFavorites
ZDialog.addMembers = ZAddMembers
ZDialog.materiallog = ZMateriallog
ZDialog.login = ZLogin

export default ZDialog
